import { SdkResource } from './common';

export const flashcard = SdkResource.from((client) => ({
  getById: (id: string) =>
    client
      .GET('/flashcard/{id}', {
        params: { path: { id } },
      })
      .then(({ data: response }) => response?.data || null),
  getByReference: (reference: string) =>
    client
      .GET('/flashcard', {
        params: { query: { filter: JSON.stringify({ reference }) } },
      })
      .then(({ data: response }) => response?.data || []),
  getDeckByReference: (reference: string) =>
    client
      .GET('/flashcard-deck', {
        params: { query: { filter: JSON.stringify({ reference }) } },
      })
      .then(({ data: response }) => response?.data || []),
}));
